"use client";

import React, { useState } from "react";
import { Facebook, Twitter, Instagram, Linkedin, MapPin, Phone, Mail, Globe } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Toggle } from "@/components/ui/toggle";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const socialLinks = [];
const workerLinks = [{
  label: "Roofing Systems",
  href: "/ServicesPage"
}, {
  label: "Siding Solutions",
  href: "/ServicesPage"
}, {
  label: "Window & Decks",
  href: "/ServicesPage"
}, {
  label: "Project Gallery",
  href: "/GalleryPage"
}, {
  label: "Company Story",
  href: "/OurStoryPage"
}];
function CustomerLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-white/5 animate-pulse rounded-sm" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="#" className="text-secondary-foreground/70 hover:text-primary transition-colors text-sm font-default">
            Home
          </Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-secondary-foreground/70 hover:text-primary transition-colors text-sm font-default">
            Our Services
          </Link>
        </li>
        <li data-index={2}>
          <Link to="#" className="text-secondary-foreground/70 hover:text-primary transition-colors text-sm font-default">
            Request Quote
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-secondary-foreground/70 hover:text-primary transition-colors text-sm font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const [isHindi, setIsHindi] = useState(false);
  return <section data-section-id="228171" id="footer" className="bg-secondary text-secondary-foreground border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {}
          <div className="space-y-6 !bg-[url(https://optimal-seahorse.10web.cloud/wp-content/uploads/2026/04/IMG_1391-1.jpg)] ![margin:0px_0px_1px_0px] !bg-[url(https://optimal-seahorse.10web.cloud/wp-content/uploads/2026/04/IMG_1391-1-e1776706973813.jpg)] !bg-[url(https://optimal-seahorse.10web.cloud/wp-content/uploads/2026/04/IMG_1391-1-e1776706973813.jpg)] !bg-[url(https://optimal-seahorse.10web.cloud/wp-content/uploads/2026/04/IMG_1391-e1776707052698.jpg)] !bg-[url(https://protechrestorationllc.com/wp-content/uploads/2026/04/IMG_1391-1-e1776706973813.jpg)] !bg-[url(https://protechrestorationllc.com/wp-content/uploads/2026/04/IMG_1391-1-e1776733232567.jpg)] !w-[200px] !h-[156px]">
            <Link to="/" className="inline-block">
              
            </Link>
            
            <div className="flex items-center gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} data-index={i} className="h-10 w-10 rounded-sm bg-white/5 flex items-center justify-center text-secondary-foreground/70 hover:bg-primary hover:text-primary-foreground transition-all duration-300 border border-white/10" aria-label={social.label}>
                    <Icon className="size-4" />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-bold tracking-tight mb-6 uppercase">The Company</h3>
            <MenuProvider menu_id="45">
              <CustomerLinks />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-bold tracking-tight mb-6 uppercase">Our Expertise</h3>
            <ul className="space-y-3">
              {workerLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-secondary-foreground/70 hover:text-primary transition-colors text-sm font-default">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-bold tracking-tight mb-6 uppercase">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-secondary-foreground/70 text-sm font-default">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <span>1544 Baldwin St, Waterbury CT 06706</span>
              </li>
              <li className="flex items-center gap-3 text-secondary-foreground/70 text-sm font-default">
                <Phone className="size-5 text-primary shrink-0" />
                <span>+1 (860) 992-3984</span>
              </li>
              <li className="flex items-center gap-3 text-secondary-foreground/70 text-sm font-default">
                <Phone className="size-5 text-primary shrink-0" />
                <span>+1 (475) 330-8380</span>
              </li>
              <li className="flex items-center gap-3 text-secondary-foreground/70 text-sm font-default">
                <Mail className="size-5 text-primary shrink-0" />
                <span>jcpalchisaca@gmail.com</span>
              </li>
            </ul>
          </div>

        </div>

        {}
        
      </div>
    </section>;
}